export enum FEATURES {
    auto_classification = 'button'
}

export const Disable = {button: {
    onClick: () => {},
    isDisabledActive: false,
    classNameButton: 'btn-inner show-opacity'
}};
